import { type RovoInstrumentedError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { generateTraceId } from './generateTraceId';

export class NoFinalResponseError extends Error implements RovoInstrumentedError {
	errorAttributes: RovoInstrumentedError['errorAttributes'];

	constructor(
		message: string,
		params: {
			traceId: string | undefined;
		},
	) {
		super(message);
		this.name = this.constructor.name;
		this.errorAttributes = {
			traceId: params.traceId ?? `NoFinalResponse-${generateTraceId()}`,
		};
	}
}
